import React from "react";

export const InfoIcon: React.FC = () => {
	return (
		<div className="hover:text-hoverBlue">
			<svg
				width="30"
				height="30"
				viewBox="0 0 28 28"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g>
					<circle
						cx="14"
						cy="14"
						r="12.75"
						fill="white"
						stroke="currentColor"
						strokeWidth="2"
					/>
					<path
						d="M15.25 8.375C15.25 8.70652 15.1183 9.02446 14.8839 9.25888C14.6495 9.4933 14.3315 9.625 14 9.625C13.6685 9.625 13.3505 9.4933 13.1161 9.25888C12.8817 9.02446 12.75 8.70652 12.75 8.375C12.75 8.04348 12.8817 7.72554 13.1161 7.49112C13.3505 7.2567 13.6685 7.125 14 7.125C14.3315 7.125 14.6495 7.2567 14.8839 7.49112C15.1183 7.72554 15.25 8.04348 15.25 8.375ZM11.5 13.0625C11.5 12.8139 11.5988 12.5754 11.7746 12.3996C11.9504 12.2238 12.1889 12.125 12.4375 12.125H14.3125C14.5611 12.125 14.7996 12.2238 14.9754 12.3996C15.1512 12.5754 15.25 12.8139 15.25 13.0625V18.375H16.1875C16.4361 18.375 16.6746 18.4738 16.8504 18.6496C17.0262 18.8254 17.125 19.0639 17.125 19.3125C17.125 19.5611 17.0262 19.7996 16.8504 19.9754C16.6746 20.1512 16.4361 20.25 16.1875 20.25H12.4375C12.1889 20.25 11.9504 20.1512 11.7746 19.9754C11.5988 19.7996 11.5 19.5611 11.5 19.3125C11.5 19.0639 11.5988 18.8254 11.7746 18.6496C11.9504 18.4738 12.1889 18.375 12.4375 18.375H13.375V14H12.4375C12.1889 14 11.9504 13.9012 11.7746 13.7254C11.5988 13.5496 11.5 13.3111 11.5 13.0625Z"
						fill="currentColor"
					/>
				</g>
			</svg>
		</div>
	);
};
